import { render, staticRenderFns } from "./CostProfitCard.vue?vue&type=template&id=a95b57f4&scoped=true"
import script from "./CostProfitCard.vue?vue&type=script&lang=js"
export * from "./CostProfitCard.vue?vue&type=script&lang=js"
import style0 from "./CostProfitCard.vue?vue&type=style&index=0&id=a95b57f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95b57f4",
  null
  
)

export default component.exports